$(document).ready(function () {
  setTimeout(() => {
      $('.slick-slide.slick-current.slick-active').removeAttr('tabindex').removeAttr('role');
      $('.slideshow__slide.grid__item').removeAttr('role').removeAttr('aria-label');
      $('.slick-track .product-single__photo__wrapper.slick-slide').removeAttr("role", "option");
  }, 5000);
  setTimeout(() => {
      $('div.prorw-product-img a').removeAttr('aria-describedby');
      $('div.prorw-product-review-title a').removeAttr('aria-describedby');
  }, 6000);
});
 
$(document).ready(function() {
  $('a[href="https://www.shopify.com?utm_campaign=poweredby&utm_medium=shopify&utm_source=onlinestore"]').attr("aria-label","Powered by Shopify, This link open in new window");
   setTimeout(() => {
    $('br').attr('aria-hidden','true'); 
   }, 500);
   $('img[data-src="https://images.squarespace-cdn.com/content/v1/5bf80e5d5ffd203cac0f1f82/1706643679311-NIMQSOBBY1I6GSX742KD/Food+plates+and+a+wine+glass+on+a+table.jpg"]').attr('alt','Plates of salad, lamb shank and rice and a glass of wine on a table');
   $('img[src="//www.anniebs.com/cdn/shop/files/image-resizer_90x90.jpg?v=1615904281"]').attr('alt','Box Of Candies with flavor variants');
   setInterval(() => {
   $('.slick-dots').removeAttr('role');
   $('.product-single__photo__nav__dots.js-product-slider-nav-dots').removeAttr('role','toolbar');
   $('.slick-list').removeAttr('aria-label');
   $('.ul.slick-dots li').removeAttr('aria-hidden','true');
   }, 2000);
});

$( document ).ready(function() {
  //wait until the last element (#checkout-step-shipping_method) being rendered
  var existCondition = setInterval(function() {
   if ($('.container.container--p-0').length) { 
    clearInterval(existCondition);
    runMyFunction2();
   }
  }, 200);

  function runMyFunction2(){
   console.log("Slider page");
   $(".home-carousel-wrapper .home-carousel.home-carousel--semi.home-carousel--title-3.js-home-carousel.home-carousel--full.slick-initialized.slick-slider.slick-dotted").removeAttr("role","toolbar");
   $(".home-carousel-wrapper .home-carousel.home-carousel--semi.home-carousel--title-3.js-home-carousel.home-carousel--full.slick-initialized.slick-slider.slick-dotted .slick-list.draggable .slick-track").removeAttr("role","listbox");
   $(".home-carousel-wrapper .home-carousel.home-carousel--semi.home-carousel--title-3.js-home-carousel.home-carousel--full.slick-initialized.slick-slider.slick-dotted .slick-list.draggable .slick-track .slick-slide.slick-current.slick-active.js-slide-active").removeAttr("role","option");
   $(".home-carousel-wrapper .home-carousel.home-carousel--semi.home-carousel--title-3.js-home-carousel.home-carousel--full.slick-initialized.slick-slider.slick-dotted ul.slick-dots").removeAttr("role","tablist");
   $(".home-carousel-wrapper .home-carousel.home-carousel--semi.home-carousel--title-3.js-home-carousel.home-carousel--full.slick-initialized.slick-slider.slick-dotted ul.slick-dots li#slick-slide00").removeAttr("role","presentation");
   $(".home-carousel-wrapper .home-carousel.home-carousel--semi.home-carousel--title-3.js-home-carousel.home-carousel--full.slick-initialized.slick-slider.slick-dotted ul.slick-dots li#slick-slide00").removeAttr("aria-controls");
   $("ul.slick-dots li#slick-slide01").removeAttr("role","presentation");
   $("ul.slick-dots li#slick-slide02").removeAttr("role","presentation");
   $(".product-single__photo__nav.js-product-slider-nav.product-single__photo__nav__dots.js-product-slider-nav-dots").removeAttr("role","toolbar");
   $(".product-single__photo__nav.js-product-slider-nav.product-single__photo__nav__dots.js-product-slider-nav-dots ul.slick-dots").removeAttr("role","tablist");
   
  }
});

$( document ).ready(function() {
  //wait until the last element (#checkout-step-shipping_method) being rendered
  var existCondition = setInterval(function() {
   if ($('ul.slick-dots').length) { 
    clearInterval(existCondition);
    runMyFunction2();
   }
  }, 200);

  function runMyFunction2(){
   console.log("nav removing");

  $('li#slick-slide00').removeAttr("aria-controls","navigation00");

  }
});

$( document ).ready(function() {
  //wait until the last element (#checkout-step-shipping_method) being rendered
  var existCondition = setInterval(function() {
   if ($('ul.slick-dots').length) { 
    clearInterval(existCondition);
    runMyFunction2();
   }
  }, 200);

  function runMyFunction2(){
   console.log("Review Page");

  $('li#slick-slide01').removeAttr("aria-controls","navigation01");

  }
});

$( document ).ready(function() {
  //wait until the last element (#checkout-step-shipping_method) being rendered
  var existCondition = setInterval(function() {
   if ($('ul.slick-dots').length) { 
    clearInterval(existCondition);
    runMyFunction2();
   }
  }, 200);

  function runMyFunction2(){
   console.log("Review Page");

  $('li#slick-slide02').removeAttr("aria-controls","navigation02");
 
  }
});

$( document ).ready(function() {
  //wait until the last element (#checkout-step-shipping_method) being rendered
  var existCondition = setInterval(function() {
   if ($('ul.slick-dots').length) { 
    clearInterval(existCondition);
    runMyFunction2();
   }
  }, 200);

  function runMyFunction2(){
   console.log("Review Page");
 

  $('li#slick-slide03').removeAttr("aria-controls","navigation03");

  }
});


$( document ).ready(function() {
  //wait until the last element (#checkout-step-shipping_method) being rendered
  var existCondition = setInterval(function() {
   if ($('ul.slick-dots').length) { 
    clearInterval(existCondition);
    runMyFunction2();
   }
  }, 200);

  function runMyFunction2(){
   console.log("Review Page");
 
  $('li#slick-slide04').removeAttr("aria-controls","navigation04");

  }
});

$( document ).ready(function() {
  //wait until the last element (#checkout-step-shipping_method) being rendered
  var existCondition = setInterval(function() {
   if ($('ul.slick-dots').length) { 
    clearInterval(existCondition);
    runMyFunction2();
   }
  }, 200);

  function runMyFunction2(){
   console.log("Review Page");
 

  $('li#slick-slide05').removeAttr("aria-controls","navigation05");
 
  }
});

$( document ).ready(function() {
  //wait until the last element (#checkout-step-shipping_method) being rendered
  var existCondition = setInterval(function() {
   if ($('ul.slick-dots').length) { 
    clearInterval(existCondition);
    runMyFunction2();
   }
  }, 200);

  function runMyFunction2(){
   console.log("Review Page");
 

  $('li#slick-slide06').removeAttr("aria-controls","navigation06");
 
  }
});


$( document ).ready(function() {
  //wait until the last element (#checkout-step-shipping_method) being rendered
  var existCondition = setInterval(function() {
   if ($('ul.slick-dots').length) { 
    clearInterval(existCondition);
    runMyFunction2();
   }
  }, 200);

  function runMyFunction2(){
   console.log("Review Page");
 

  $('li#slick-slide07').removeAttr("aria-controls","navigation07");
 
  }
});

$( document ).ready(function() {
  //wait until the last element (#checkout-step-shipping_method) being rendered
  var existCondition = setInterval(function() {
   if ($('.product-single__photo__nav').length) { 
    clearInterval(existCondition);
    runMyFunction2();
   }
  }, 200);

  function runMyFunction2(){
   console.log("toolbar remove");
 

  $('.product-single__photo__nav__dots.js-product-slider-nav-dots').removeAttr("role","toolbar");
 

  }
});

  $( document ).ready(function() {
  //wait until the last element (#checkout-step-shipping_method) being rendered
  var existCondition = setInterval(function() {
   if ($('.o-layout__item.slick-slide.slick-current.slick-active').length) { 
    clearInterval(existCondition);
    runMyFunction2();
   }
  }, 200);

  function runMyFunction2(){
   console.log("Remove Attr");
   $(".o-layout__item.slick-slide.slick-current.slick-active").removeAttr('aria-describedby','slick-slide00');
   
  }
});

$( document ).ready(function() {
  //wait until the last element (#checkout-step-shipping_method) being rendered
  var existCondition = setInterval(function() {
   if ($('#slick-slide00').length) { 
    clearInterval(existCondition);
    runMyFunction2();
   }
  }, 200);

  function runMyFunction2(){
   console.log("role removing");
   $('#slick-slide00').removeAttr("role","presentation");
   
  
  }
});

$( document ).ready(function() {
  //wait until the last element (#checkout-step-shipping_method) being rendered
  var existCondition = setInterval(function() {
   if ($('#slick-slide01').length) { 
    clearInterval(existCondition);
    runMyFunction2();
   }
  }, 200);

  function runMyFunction2(){
   console.log("role removing");
   $('#slick-slide01').removeAttr("role","presentation");
   
  
  }
});

$( document ).ready(function() {
  //wait until the last element (#checkout-step-shipping_method) being rendered
  var existCondition = setInterval(function() {
   if ($('#slick-slide02').length) { 
    clearInterval(existCondition);
    runMyFunction2();
   }
  }, 200);

  function runMyFunction2(){
   console.log("role removing");
   $('#slick-slide02').removeAttr("role","presentation");
   
  
  }
});

$( document ).ready(function() {
  //wait until the last element (#checkout-step-shipping_method) being rendered
  var existCondition = setInterval(function() {
   if ($('#slick-slide02').length) { 
    clearInterval(existCondition);
    runMyFunction2();
   }
  }, 200);

  function runMyFunction2(){
   console.log("role removing");
   $('#slick-slide03').removeAttr("role","presentation");
   
  
  }
});
   
$( document ).ready(function() {
  //wait until the last element (#checkout-step-shipping_method) being rendered
  var existCondition = setInterval(function() {
   if ($('#slick-slide02').length) { 
    clearInterval(existCondition);
    runMyFunction2();
   }
  }, 200);

  function runMyFunction2(){
   console.log("role removing");
   $('#slick-slide02').removeAttr("aria-selected","true");
   
  
  }
});

$( document ).ready(function() {
  //wait until the last element (#checkout-step-shipping_method) being rendered
  var existCondition = setInterval(function() {
   if ($('#slick-slide03').length) { 
    clearInterval(existCondition);
    runMyFunction2();
   }
  }, 200);

  function runMyFunction2(){
   console.log("role removing");
   $('#slick-slide03').removeAttr("aria-selected","false");
   
  
  }
});

$( document ).ready(function() {
  //wait until the last element (#checkout-step-shipping_method) being rendered
  var existCondition = setInterval(function() {
   if ($('.slick-track').length) { 
    clearInterval(existCondition);
    runMyFunction2();
   }
  }, 200);

  function runMyFunction2(){
   console.log("role removing");
   $('.product-single__photo__wrapper.slick-slide.slick-current.slick-active').removeAttr("aria-describedby","slick-slide00");
   $('.product-single__photo__wrapper slick-slide').removeAttr("aria-describedby","slick-slide01")
   $('.product-single__photo__wrapper slick-slide').removeAttr("aria-describedby","slick-slide02")
  }
});


$( document ).ready(function() {
  //wait until the last element (#checkout-step-shipping_method) being rendered
  var existCondition = setInterval(function() {
   if ($('#slick-slide00').length) { 
    clearInterval(existCondition);
    runMyFunction2();
   }
  }, 200);

  function runMyFunction2(){
   console.log("role removing");
   $('#slick-slide00').removeAttr("aria-selected","true");
   
  
  }
});

$( document ).ready(function() {
  //wait until the last element (#checkout-step-shipping_method) being rendered
  var existCondition = setInterval(function() {
   if ($('#slick-slide01').length) { 
    clearInterval(existCondition);
    runMyFunction2();
   }
  }, 200);

  function runMyFunction2(){
   console.log("role removing");
   $('#slick-slide01').removeAttr("aria-selected","true");
   
  
  }
});
              


$( document ).ready(function() {
  //wait until the last element (#checkout-step-shipping_method) being rendered
  var existCondition = setInterval(function() {
   if ($('ul.slick-dots').length) { 
    clearInterval(existCondition);
    runMyFunction2();
   }
  }, 200);

  function runMyFunction2(){
   console.log("role removing");
   $('ul.slick-dots').removeAttr("role","tablist");
   
  
  }
});

$( document ).ready(function() {
  //wait until the last element (#checkout-step-shipping_method) being rendered
  var existCondition = setInterval(function() {
   if ($('.slick-track').length) { 
    clearInterval(existCondition);
    runMyFunction2();
   }
  }, 200);

  function runMyFunction2(){
   console.log("role removing");
   $('.product-single__photo__wrapper.slick-slide.slick-current.slick-active').removeAttr("role","option");
 
   
  
  }
});


$( document ).ready(function() {
  //wait until the last element (#checkout-step-shipping_method) being rendered
  var existCondition = setInterval(function() {
   if ($('.product-single__photo__nav.js-product-slider-nav').length) { 
    clearInterval(existCondition);
    runMyFunction2();
   }
  }, 200);

  function runMyFunction2(){
   console.log("role removing");
 
  $('.product-single__photo__nav__dots.js-product-slider-nav-dots').removeAttr("role","toolbar");
  $('.product-single__photo__nav__dots.js-product-slider-nav-dots ul.slick-dots').removeAttr("role","tablist");
  
  }
});


$( document ).ready(function() {
  //wait until the last element (#checkout-step-shipping_method) being rendered
  var existCondition = setInterval(function() {
   if ($('ul.slick-dots').length) { 
    clearInterval(existCondition);
    runMyFunction2();
   }
  }, 200);

  function runMyFunction2(){
   console.log("aria removing");
   $('li#slick-slide03').removeAttr("aria-hidden","false");
   $('li#slick-slide04').removeAttr("aria-hidden","true");
   $('li#slick-slide05').removeAttr("aria-hidden","true");
   $('li#slick-slide06').removeAttr("aria-hidden","true");
   $('li#slick-slide07').removeAttr("aria-hidden","true");
   $('li#slick-slide09').removeAttr("aria-hidden","true");
   $('li#slick-slide10').removeAttr("aria-hidden","true");
   $('li#slick-slide11').removeAttr("aria-hidden","true");
   $('li#slick-slide08').removeAttr("aria-hidden","true");
   $('li#slick-slide12').removeAttr("aria-hidden","true");
   
  }
});


$( document ).ready(function() {
  //wait until the last element (#checkout-step-shipping_method) being rendered
  var existCondition = setInterval(function() {
   if ($('ul.slick-dots').length) { 
    clearInterval(existCondition);
    runMyFunction2();
   }
  }, 200);

  function runMyFunction2(){
   console.log("aria removing");  
   $('li#slick-slide04').removeAttr("role","presentation");
   $('li#slick-slide05').removeAttr("role","presentation");
   $('li#slick-slide06').removeAttr("role","presentation");
   $('li#slick-slide07').removeAttr("role","presentation");
   $('li#slick-slide09').removeAttr("role","presentation");
   $('li#slick-slide10').removeAttr("role","presentation");
   $('li#slick-slide11').removeAttr("role","presentation");
   $('li#slick-slide08').removeAttr("role","presentation");
   $('li#slick-slide12').removeAttr("role","presentation");
   
  }
});

$( document ).ready(function() {
//wait until the last element (#checkout-step-shipping_method) being rendered
var existCondition = setInterval(function() {
if ($('.product-single__photo.js-product-slider.slick-initialized.slick-slider.slick-dotted').length) { 
clearInterval(existCondition);
runMyFunction2();
}
}, 200);

function runMyFunction2(){
console.log("role removing");
$('.slick-track').removeAttr("role","listbox");
   
  
 }
});

                  
$( document ).ready(function() {
//wait until the last element (#checkout-step-shipping_method) being rendered
var existCondition = setInterval(function() {
if ($('ul.slick-dots').length) { 
clearInterval(existCondition);
runMyFunction2();
}
}, 200);

function runMyFunction2(){
console.log("aria-hidden removing");
$('li#slick-slide00').removeAttr("aria-hidden","true");

  }
});

$( document ).ready(function() {
//wait until the last element (#checkout-step-shipping_method) being rendered
var existCondition = setInterval(function() {
if ($('ul.slick-dots').length) { 
clearInterval(existCondition);
  runMyFunction2();
}
}, 200);
              
function runMyFunction2(){
console.log("aria-hidden removing");
$('li#slick-slide01').removeAttr("aria-hidden","true");         
 }
  });
              
$( document ).ready(function() {
//wait until the last element (#checkout-step-shipping_method) being rendered
var existCondition = setInterval(function() {
if ($('ul.slick-dots').length) { 
clearInterval(existCondition);
runMyFunction2();
}
}, 200);
              
function runMyFunction2(){
console.log("role removing");
$('li#slick-slide02').removeAttr("aria-hidden","true");
}
});

$( document ).ready(function() {
  //wait until the last element (#checkout-step-shipping_method) being rendered
  var existCondition = setInterval(function() {
  if ($('.slick-track').length) { 
  clearInterval(existCondition);
  runMyFunction2();
  }
  }, 200);
                
  function runMyFunction2(){
  console.log("aria-hidden removing");
  $('.slick-slide').removeAttr("aria-hidden","true");
  }
  });

$( document ).ready(function() {
  //wait until the last element (.slick-list.draggable) being rendered
  var existCondition = setInterval(function() {
  if ($('.slick-list.draggable').length) { 
  clearInterval(existCondition);
  runMyFunction2();
  }
  }, 200);
                
  function runMyFunction2(){
  console.log("Role Option Remove AK");
  $('.slick-track .product-single__photo__wrapper.slick-slide').removeAttr("role", "option");
  }
  });

$( document ).ready(function() {
  //wait until the last element (.slick-list.draggable) being rendered
  var existCondition = setInterval(function() {
  if ($('.slick-list.draggable').length) { 
  clearInterval(existCondition);
  runMyFunction2();
  }
  }, 200);
                
  function runMyFunction2(){
  console.log("Role list Remove and aria-label add AK");
  $('.product-single__photo.js-product-slider.slick-initialized.slick-slider .slick-list.draggable .slick-track').removeAttr("role", "listbox");
  // $('.product-single__photo.js-product-slider.slick-initialized.slick-slider .slick-list.draggable .slick-track').attr("aria-label", "gallery").attr('role','region');
  }
  });

$( document ).ready(function() {
  //wait until the last element (.slick-list.draggable) being rendered
  var existCondition = setInterval(function() {
  if ($('.product-single__photos.product-single__photos--large.js-sr-loaded').length) { 
  clearInterval(existCondition);
  runMyFunction2();
  }
  }, 200);
                
  function runMyFunction2(){
  console.log("Role tablist Remove AK");
  $('.product-single__photo__nav.js-product-slider-nav .product-single__photo__nav__dots.js-product-slider-nav-dots ul.slick-dots').removeAttr("role", "tablist");
  }
  });

  document.addEventListener('DOMContentLoaded', function() {
    var backToTopButton = document.getElementById('back-to-top');
  
    window.onscroll = function() {
        if (window.pageYOffset > 300) {
            backToTopButton.style.display = 'block';
        } else {
            backToTopButton.style.display = 'none';
        }
    };
  
    backToTopButton.onclick = function(e) {
        e.preventDefault();
        window.scrollTo({ top: 0, behavior: 'smooth' });
  
        // Set focus to the top of the page or the button itself after scrolling
        window.setTimeout(function() {
            document.getElementById('backtoheader').focus(); // If focusing the top element
            // backToTopButton.focus(); // If focusing the button itself
        }, 600); // Adjust the timeout duration to match the scroll duration
    };
  });

  document.addEventListener('DOMContentLoaded', function() {
    const accordionTriggers = document.querySelectorAll('.js-accordion-trigger');

    accordionTriggers.forEach(trigger => {
        trigger.addEventListener('click', function(event) {
            event.preventDefault();
            const isExpanded = trigger.getAttribute('aria-expanded') === 'true';
            const content = document.querySelector(trigger.getAttribute('href'));

            // Toggle the aria-expanded attribute
            trigger.setAttribute('aria-expanded', !isExpanded);

            // Toggle the visibility of the content
            if (isExpanded) {
                content.setAttribute('aria-hidden', 'true');
                content.style.display = 'none';
            } else {
                content.setAttribute('aria-hidden', 'false');
                content.style.display = 'block';
            }
        });
    });
});

$( document ).ready(function() {
  var existCondition = setInterval(function() {
   if ($('.slick-list').length) { 
    clearInterval(existCondition);
    runMyFunction2();
   }
  }, 200);

  function runMyFunction2(){
   console.log("removing label");

  $('.slick-list .draggable').removeAttr("aria-label");

  }
});